import {
    AfterContentInit,
    Component, ContentChildren, ElementRef, Input,
    OnDestroy,
    OnInit,
    QueryList, TemplateRef, ViewChild
} from '@angular/core';
import {CommonModule, NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {customSetInterval} from "@cybfed/core/helpers/overrided-timers";


@Component({
    selector: 'white-label-vertical-carousel',
    templateUrl: './vertical-carousel.component.html',
    imports: [
        NgClass,
        CommonModule,
        TranslateModule

    ],
    standalone: true,
    providers: [
    ]
})
export class VerticalCarouselComponent implements OnInit, OnDestroy, AfterContentInit {
    @ViewChild('track') trackRef!: ElementRef<HTMLDivElement>;
    @ContentChildren(TemplateRef) contentTemplates!: QueryList<TemplateRef<any>>;
    @Input() interval: number = 2000;

    templates: TemplateRef<any>[] = [];

    currentIndex = 0;
    intervalId: any;

    // Adjust this height based on your item height class (e.g., h-24)
    // h-24 is usually ~6rem. Assume base font-size is 16px => 6rem ~ 96px.
    // Set a known height in rem or px for consistency.
    itemHeightRem = 6;

    ngOnInit(): void {
        // Autoplay every 2 seconds
        this.play()
    }

    ngAfterContentInit(): void {
        this.templates = this.contentTemplates.toArray();
    }

    ngOnDestroy(): void {
        if (this.intervalId) clearInterval(this.intervalId);
    }

    nextSlide() {
        this.currentIndex++;
        this.updateTransform();
    }

    prevSlide() {
        const length = this.templates.length;
        this.currentIndex--;
        if (this.currentIndex < 0) {
            // Jump from second set
            const trackEl = this.trackRef.nativeElement;
            trackEl.style.transition = 'none';
            this.currentIndex = this.currentIndex + length;
            trackEl.style.transform = `translateY(${-this.currentIndex * this.itemHeightRem}rem)`;
            trackEl.getBoundingClientRect(); // force layout
            trackEl.style.transition = 'transform 0.7s ease-in-out';
        }
        this.updateTransform();
    }

    updateTransform() {
        const trackEl = this.trackRef.nativeElement;
        const length = this.templates.length;

        if (this.currentIndex >= length) {
            // Jump back to start without transition for seamless loop
            trackEl.style.transition = 'none';
            this.currentIndex = this.currentIndex - length;
            trackEl.style.transform = `translateY(${-this.currentIndex * this.itemHeightRem}rem)`;
            trackEl.getBoundingClientRect(); // force reflow
            trackEl.style.transition = 'transform 0.7s ease-in-out';
        } else {
            // Normal forward transition
            trackEl.style.transition = 'transform 0.7s ease-in-out';
            trackEl.style.transform = `translateY(${-this.currentIndex * this.itemHeightRem}rem)`;
        }
    }

    pause(){
        if (this.intervalId) clearInterval(this.intervalId);
    }

    play(){
        this.intervalId = customSetInterval(() => {
            this.nextSlide();
        }, this.interval);
    }
}

